import { render, staticRenderFns } from "./TranslationEdit.vue?vue&type=template&id=07b3bfc5&"
import script from "./TranslationEdit.vue?vue&type=script&lang=js&"
export * from "./TranslationEdit.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports